import { format, parseISO } from 'date-fns';
import i18next from 'i18next';

interface CreateFastFilterDateLabelProps {
  createTimeGte: string | undefined;
  createTimeLt: string | undefined;
}

const formatDate = (date: string) => (
  format(parseISO(date), 'dd.MM.yyyy')
);

export const createFastFilterDateLabel = ({
  createTimeGte,
  createTimeLt,
}: CreateFastFilterDateLabelProps): string => {
  if (createTimeGte && createTimeLt) {
    return `${i18next.t('от')} ${formatDate(createTimeGte)} ${i18next.t('до')} ${formatDate(createTimeLt)}`;
  }
  if (createTimeGte) {
    return `${i18next.t('от')} ${formatDate(createTimeGte)}`;
  }
  if (createTimeLt) {
    return `${i18next.t('до')} ${formatDate(createTimeLt)}`;
  }
  return '';
};
